import { Link } from "react-router-dom";

const ContactCTA = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-5xl mx-auto px-6 text-center">

        <h2 className="text-4xl font-bold text-gray-900 mb-12">
          How can we help you succeed?
        </h2>

        <button
          onClick={() => window.location.href = "/contact"}
          className="bg-gradient-to-r from-purple-700 to-pink-500 text-white px-8 py-4 rounded-full font-semibold transition hover:scale-105 duration-300"
        >
          Find Your Solution
        </button>
      </div>
    </section>
  );
};

export default ContactCTA;